import type { IPessoaJuridica } from "../../components/Interfaces";
import api, { apiCep, apiCnpj, apiConvenio, apiCtrlDoc, apiEntidade, apiLocalidades, apiPlanosBeneficios } from "../../services/api";


export const carregaListaPaises = async () => {
  return apiLocalidades.get(`/paises`);
}

export const carregaListaUF = async () => {
  return apiLocalidades.get(`/estados`);
}
export const carregaListaNaturezasJuridicas = async () => {
  return api.get(`/naturezas-juridicas`);
}

export const carregaListaNaturezasJuridicasIbge = async () => {
  return api.get(`/naturezas-juridicas-ibge`);
}

export const carregaListaMunicipios = async (codigoEstado: any) => {
  return apiLocalidades.get(`/estados/${codigoEstado}/municipios`);
}

export const carregaListaFundamentacaoLegal = async () => {
  return apiEntidade.get(`/fundamentacao-legal`);
}

export const carregaListaTipoEfpc = async () => {
  return apiEntidade.get(`/tipo-efpc`);
}

export const carregaListaTipoRegulamento = async () => {
  return apiPlanosBeneficios.get(`/tipo-regulamento`);
}

export const carregaListaTipoBeneficio = async () => {
  return apiPlanosBeneficios.get(`/tipo-beneficio`);
}

export const carregaListaTipoRegraCalculo = async () => {
  return apiPlanosBeneficios.get(`/tipo-regra-calculo`);
}

export const carregaListaTipoRequisitoElegibilidade = async () => {
  return apiPlanosBeneficios.get(`/tipo-requisito-elegibilidade`);
}

export const carregaListaTipoInstituto = async () => {
  return apiPlanosBeneficios.get(`/tipo-instituto`);
}

export const carregaListaTipoComponenteResgatePortabilidade = async () => {
  return apiPlanosBeneficios.get(`/tipo-componente-resgate-portabilidade`);
}

export const carregaListaCaracteristica = async () => {
  return apiPlanosBeneficios.get(`/caracteristica`);
}

export const carregaListaTipoConvenio = async () => {
  return apiConvenio.get(`/tipo-convenio`);
}

export const carregaListaTipoInstituidor = async () => {
  return apiConvenio.get(`/tipo-instituidor`);
}

export const carregaListaModalidade = async () => {
  return apiPlanosBeneficios.get(`/modalidade`);
}

export const carregaListaUnidadeMedidaPercentualMonetario = async () => {
  return apiPlanosBeneficios.get(`/unidade-medida-percentual-monetario`);
}

export const carregaListaUnidadeMedidaPrazo = async () => {
  return apiPlanosBeneficios.get(`/unidade-medida-prazo`);
}

export const carregaListaRegimeFinanceiro = async () => {
  return apiPlanosBeneficios.get(`/regime-financeiro`);
}

export const carregaListaMetodoFinanciamento = async () => {
  return apiPlanosBeneficios.get(`/captalizacao-metodo-financiamento`);
}

export const carregaListaTipoExpressaoBeneficio = async () => {
  return apiPlanosBeneficios.get(`/tipo-expressao-beneficio`);
}

export const carregaListaPrazoPagamento = async () => {
  return apiPlanosBeneficios.get(`/prazo-pagamento`);
}

export const carregaListaDocumento = async (bitwise: string) => {
  return apiCtrlDoc.get(`/${bitwise}`);
}

export const existeNumeroCadastrado = async (tipoIdentificador: number, value: string) => {
  return api.get(`/ultimo/${tipoIdentificador}/${value}/numero`);
}

export const consultaCNPJReceita = async (cnpj: string) => {
  let cnpjNumeros = cnpj.replace('.', '').replace('-', '');
  return apiCnpj.get(`/${cnpjNumeros}`);

}

export const carregaEstados = async () => {
  return apiLocalidades.get(`/estados`);
};

export const carregaCidades = async (value: BigInteger) => {
  return apiLocalidades.get(`/estados/${value}/municipios`);
};

export const carregaCidadeIbge = async (value: BigInteger) => {
  return apiLocalidades.get(`/municipios/${value}`);
};

export const carregaCEP = async (cep: string) => {
  let cepNumeros = cep.replace('.', '').replace('-', '');
  return apiCep.get(`/${cepNumeros}`);
};

export const consultaPessoasJuridicas = async (query: string) => {
  return api.get(query);
};

export const carregaPessoaJuridica = async (id: string) => {
  return api.get(`/${id}`);
};

export const cadastraPessoaJuridica = async (query: string, body: IPessoaJuridica) => {
  return api.post(`/versionar/${body.numero}/numero`, body);
}


export const deletaPessoaJuridica = async (id: any) => {
  return api.post(`/deletar/${id}/serie`);
}

export const consultaHistorico = (serie: number, linhaPorPagina: number, pagina: number) => {
  let body = { serie: serie }
  return api.post(`/consulta?limit=${linhaPorPagina}&page=${pagina}`, body);
};
